import { render, staticRenderFns } from "./VaSimplePalettePicker.demo.vue?vue&type=template&id=3cd77fc8&"
import script from "./VaSimplePalettePicker.demo.vue?vue&type=script&lang=js&"
export * from "./VaSimplePalettePicker.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports